<template>
	<div class="SaaSDataList">
		<el-row class="function">
			<el-col :span="5">
				<el-input v-model.trim="name" placeholder="功能名称搜索" clearable></el-input>
			</el-col>
			<el-col :span="3">
				<el-checkbox v-model="checked" class="checked">查看已配置功能</el-checkbox>
			</el-col>
			<el-col :span="5" class="currencySelect">
				<el-select v-model="selectValue" placeholder="币种切换">
					<el-option
						v-for="optionItem in currencyOptions"
						:key="optionItem.value"
						:label="optionItem.label"
						:value="optionItem.value"
						:disabled="optionItem.disabled"
					>
					</el-option>
				</el-select>
			</el-col>
		</el-row>
		<data-list :data="data" height="600" :columns="column" :table-style="{ name: 'mixture' }">
		</data-list>
		<div slot="bottom" class="total-prices">
			<span>总价:{{ totalObj.totalPrices }}</span>
			<span>总优惠:{{ totalObj.totalDiscount }}</span>
			<span>优惠后总价:{{ totalObj.afterDiscount }}</span>
		</div>
	</div>
</template>

<script>
import { currencies } from '@/common/dictionary.js';
import setmeal from '@/backend/services/account/setmeal.js';
import filters from '@/mixins/filters.js';

let { money } = filters.filters;

export default {
	name: 'SaaSDataList',
	props: ['value'],
	data() {
		let that = this;
		return {
			name: '',
			checked: false,
			selectValue: 127001,
			currencyOptions: currencies,
			dataObj: {},
			column: [
				{
					label: '使用',
					bind: 'status',
					type: 'checkbox',
					width: 50,
					align: 'center',
					change(val, row) {
						let { dataObj } = that;
						Object.keys(dataObj).forEach(key => {
							dataObj[key].forEach(item => {
								if (item.id == row.id) {
									item.status = val;
								}
							});
						});

						that.setData();
					},
				},
				{
					label: '功能名称',
					bind: 'name',
					type: 'popoverView',
				},
				{
					label: '版本',
					bind: 'version',
				},
				{
					label: '单价',
					bind: 'price',
					type: 'percentage',
					dataStyle(val) {
						let { selectValue: currency } = that;
						return money(val, currency);
					},
				},
				{
					label: '单位',
					bind: 'unitName',
					width: 50,
				},
				{
					label: '量级',
					type: 'inputNumber',
					bind: 'functionNumber',
					size: 'mini',
					width: 200,
					min: 1,
					align: 'center',
					change(val, _oldVal, row) {
						let { dataObj, selectValue } = that;
						let custom = {
							functionNumber: val,

							// 实际充值
							actualCosts: val * row.price,
							// 服务费
							functionTotalServiceFee: val * row.price * (row.serviceChargeProportion / 100),
							// 税费
							functionTotalTaxFee: val * row.price * (row.taxesProportion / 100),
							// 总价
							singleFunctionTotalPrice:
								val * row.price +
								val * row.price * (row.serviceChargeProportion / 100) +
								val * row.price * (row.taxesProportion / 100),
						};
						//优惠后的价格
						custom.afterDiscount = custom.singleFunctionTotalPrice - row.preferentialPrice;
						dataObj[selectValue].forEach(item => {
							if (item.id == row.id) {
								item = Object.assign(item, custom);
							}
						});
						that.setData();
					},
				},
				{
					label: '价格',
					bind: 'singleFunctionTotalPrice',
					type: 'skyInputBtn',
					content: '价格编辑仅可输入整数',
					unit: () => {
						let { selectValue: currency } = that;
						return money(0, currency, false, true);
					},
					width: 110,
					showUpdate({ type }) {
						return type === 3 || type === 7;
					},
					change(val, row) {
						let { dataObj, selectValue } = that;
						if (!val) {
							that.$message.info('数据不可以为空');
							return false;
						}
						if (!row) {
							that.$message.info('数据错误，请稍后重试！');
							return false;
						}

						dataObj[selectValue].forEach(item => {
							if (item.id == row.id) {
								item.singleFunctionTotalPrice = parseFloat(val);
							}
						});
						that.setData();
					},
				},
				{
					label: '优惠',
					bind: 'preferentialPrice',
					type: 'skyInput',
					width: 120,
					change(val, row) {
						let { dataObj, selectValue } = that;

						if (!/(^[0-9]\d*$)/.test(val) && val !== '') {
							return '只接受正整数';
						}
						if (parseInt(val) > row.singleFunctionTotalPrice) {
							return '请勿大于优惠前价格';
						}
						let custom = {
							// 优惠后价格
							afterDiscount: row.singleFunctionTotalPrice - val,
							preferentialPrice: parseInt(val) || 0,
						};
						dataObj[selectValue].forEach(item => {
							if (item.id == row.id) {
								item = Object.assign(item, custom);
							}
						});
						that.setData();
					},
				},
				{
					label: '详情',
					type: 'custInfo',
					text: [
						{
							label: '优惠后价格',
							bind: 'afterDiscount',
							custValue(val) {
								let { selectValue: currency } = that;
								if (val.preferentialPrice == 0) {
									return money(val.singleFunctionTotalPrice, currency);
								} else {
									return money(val.afterDiscount, currency);
								}
							},
						},
						{
							label: '服务费',
							bind: 'functionTotalServiceFee',
							custValue(val) {
								let { selectValue: currency } = that;
								if (val.functionTotalServiceFee == 0) {
									return '-';
								} else {
									return money(val.functionTotalServiceFee, currency);
								}
							},
						},
						{
							label: '税费',
							bind: 'functionTotalTaxFee',
							custValue(val) {
								let { selectValue: currency } = that;
								if (val.functionTotalTaxFee == 0) {
									return '-';
								} else {
									return money(val.functionTotalTaxFee, currency);
								}
							},
						},
						{
							label: '实际充值',
							bind: 'actualCosts',
							custValue(val) {
								let { selectValue: currency } = that;
								return money(val.actualCosts, currency);
							},
						},
						{
							label: '税费比例',
							bind: 'taxesProportion',
							custValue(row) {
								return `${row.taxesProportion}%`;
							},
						},
						{
							label: '服务费比例',
							bind: 'serviceChargeProportion',
							custValue(row) {
								return `${row.serviceChargeProportion}%`;
							},
						},
					],
				},
			],
		};
	},
	computed: {
		data(self) {
			let { dataObj } = self;
			let list = self.filterList(dataObj);
			return list;
		},
		totalObj(self) {
			let { selectValue: currency, dataObj } = self;

			let totalPrices = 0;
			let totalDiscount = 0;
			let afterDiscount = 0;

			if (!dataObj[currency])
				return {
					totalPrices: money(0, currency), // 总价
					totalDiscount: money(0, currency), // 总优惠
					afterDiscount: money(0, currency), // 优惠后总价
				};

			dataObj[currency].map(item => {
				if (item.status) {
					totalPrices += item.singleFunctionTotalPrice;
					totalDiscount += item.preferentialPrice;
				}
			});
			afterDiscount = totalPrices - totalDiscount;
			return {
				totalPrices: money(totalPrices, currency), // 总价
				totalDiscount: money(totalDiscount, currency), // 总优惠
				afterDiscount: money(afterDiscount, currency), // 优惠后总价
			};
		},
	},
	mounted() {
		this.getActiveFeatureList();
	},
	methods: {
		// 获取以启用套餐列表
		async getActiveFeatureList() {
			let res = await setmeal.activeFeatureList();
			this.dataObj = this.transformData(res.data);
			this.setData();
		},
		// 数据处理
		transformData(data) {
			let { value } = this;

			const result = {};

			data.forEach(item => {
				item.priceList.forEach(priceEntry => {
					const { currency, price } = priceEntry;

					// 如果 result 中没有当前 currency 的键，则创建一个空数组
					if (!result[currency]) {
						result[currency] = [];
					}

					let custom = {
						status: false, // 选中状态
						functionNumber: 1, // 量级
						afterDiscount: 1,
						actualCosts: price, //实际充值
						preferentialPrice: item.preferentialPrice || 0,
						functionTotalServiceFee: price * (item.serviceChargeProportion / 100), // 服务费
						functionTotalTaxFee: price * (item.taxesProportion / 100), // 税费
						singleFunctionTotalPrice:
							price +
							price * (item.serviceChargeProportion / 100) +
							price * (item.taxesProportion / 100), // 实际充值
					};

					// 构造符合要求的对象
					const formattedItem = {
						...Object.assign(item, custom),
						currency,
						price,
					};

					// 将对象添加到相应的 currency 分类中
					result[currency].push(formattedItem);
				});
			});

			if (value) {
				value.forEach(({ currency, functionItemList }) => {
					if (result[currency]) {
						result[currency] = result[currency].map(item => {
							// 在 functionItemList 中查找对应 id 的对象
							const match = functionItemList.find(({ id }) => id === item.id);

							if (match) {
								let { singleFunctionTotalPrice, functionNumber, preferentialPrice } = match;

								if (!singleFunctionTotalPrice) {
									item.functionNumber = functionNumber;
								} else {
									item.actualCosts = item.price * functionNumber;
									item.afterDiscount = singleFunctionTotalPrice - preferentialPrice;
									item = Object.assign(item, match);
								}
								item.currency = currency;
								item.status = true;
							}

							return item;
						});
					}
				});
			}

			return result;
		},
		// 自定义过滤
		filterList(obj) {
			let { name, checked, selectValue } = this;

			var arr;
			var reg = new RegExp(name);
			if (!obj[selectValue]) return [];

			arr = obj[selectValue].filter(({ name }) => {
				return reg.test(name);
			});

			if (checked) {
				arr = arr.filter(item => {
					return item.status;
				});
			}
			return arr;
		},
		// 向外抛出数据
		setData() {
			let { dataObj } = this;
			let inputObj = _.cloneDeep(dataObj);
			const result = Object.entries(inputObj)
				.map(([currency, functionItemList]) => {
					functionItemList = functionItemList
						.filter(item => item.status)
						.map(item => {
							let { currency, functionNumber, id, preferentialPrice, singleFunctionTotalPrice } =
								item;
							return { currency, functionNumber, id, preferentialPrice, singleFunctionTotalPrice };
						});
					return {
						currency: Number(currency),
						functionItemList,
					};
				})
				.filter(item => {
					return item.functionItemList.length > 0;
				});
			this.$emit('input', result);
		},
	},
};
</script>

<style lang="scss" scoped>
.SaaSDataList {
	.total-prices {
		width: 100%;
		padding: 10px 0;
		padding-right: 20px;
		text-align: right;
		font-size: 18px;
		font-weight: bold;

		span {
			margin-left: 20px;
		}
	}

	.function {
		margin: 10px 0 10px 0;

		.currencySelect {
			.currencySelect-title {
				margin-right: 10px;
			}
		}
	}

	.checked {
		margin-left: 20px;
	}
}
</style>
